import appointment from 'locales/dental/en/counter/appointment.json'
import doctorSchedule from 'locales/dental/en/counter/doctor-schedule.json'
import patientManagement from 'locales/dental/en/counter/patient-management.json'
import register from 'locales/dental/en/counter/register.json'
import recallLists from 'locales/dental/en/counter/recallLists.json'
import manageDoctorFee from 'locales/dental/en/counter/manage-doctor-fee.json'
import manageDoctorLabFee from 'locales/dental/en/counter/manage-doctor-lab-fee.json'

export const CounterEN = {
  ...appointment,
  ...doctorSchedule,
  ...patientManagement,
  ...register,
  ...recallLists,
  ...manageDoctorFee,
  ...manageDoctorLabFee
}
